import { create } from 'zustand';

interface MeasurementState {
  measurementMode: boolean;
  toggleMeasurementMode: () => void;
}

export const useMeasurementStore = create<MeasurementState>()((set) => ({
  measurementMode: false,
  toggleMeasurementMode: () => set((state) => ({ measurementMode: !state.measurementMode })),
}));
